import React from 'react';
import SelectItem from './SelectItem';
import { toggleAllFromList, checkForChanges } from '../utilities';

const ItemList = ({ items, selectedItems, onPageSelectionChange, onShowDraftPages, isDraftShown, onShowPublished, isPublishedShown }) => {

	// SORT THE PAGES ALPHABETICALLY
	items = Array.from(items);
	items.sort((a, b) => {

		var x = a.querySelector('title').textContent.toLowerCase();
		var y = b.querySelector('title').textContent.toLowerCase();
		if (x < y) { return -1; }
		if (x > y) { return 1; }
		return 0;
		});

	const saveChanges = (event) => {

		// HIDE THE CHANGES BUTTONS AFTER SAVING
		event.target.parentNode.style.display = 'none';
		onPageSelectionChange(document.querySelector('.page-list'));
	}

	const cancelChanges = (event) => {

		// RESTORE LIST STATE AND HIDE THE CHANGES BUTTONS
		event.target.parentNode.style.display = 'none';
		const selection = document.querySelector('.page-list');
		const pageList = Array.from(selection.querySelectorAll('li'));

		for (const page in pageList) {

			if ( selectedItems.includes(pageList[page].getAttribute('data-id')) ) {

				pageList[page].classList.add('selected');
			} else {

				pageList[page].classList.remove('selected');
			}
		}
	}

	const togglePages = (event, isSelectAll) => {

		// TOGGLE ALL ITEMS
		const list = document.querySelector('.page-list');
		toggleAllFromList(event, list, isSelectAll);

		// CHECK FOR CHANGES
		const newSelectedPages = Array.from(list.querySelectorAll('.selected'));
		const hasChanges = checkForChanges(selectedItems, newSelectedPages);

		document.querySelector('.manage-changes').style.display = hasChanges ? 'block' : 'none';
	}

	return (

		<div className='ph2 pv4'>
			<div className='overflow-hidden'>
				<button
					onClick={(e) => (togglePages(e, true))}
					className='mh1 pa2 pointer'
				> Select All</button>
				<button
					onClick={(e) => (togglePages(e, false))}
					className='mh1 pa2 pointer'
				> Deselect All</button>
				<label className='pointer mh2'><input type='checkbox' name='show-published' checked={isPublishedShown} onChange={onShowPublished} /> Published</label>
				<label className='pointer mh2'><input type='checkbox' name='exclude-drats' checked={isDraftShown} onChange={onShowDraftPages} /> Draft</label>
				<div className='manage-changes fr dn'>
					<button className='cancel-changes mh1 pa2 pointer' onClick={(e) => (cancelChanges(e))} >Cancel Changes</button>
					<button className='save-changes bg-brand-magenta white gow mh1 pa2 pointer bn' onClick={(e) => (saveChanges(e))} >Save Changes</button>
				</div>
			</div>
			<div className='ma2 pa2 bt bb bw1 b--black-025'>{selectedItems.length} page(s) selected</div>
			<ul className='list page-list ma0 pa0'>
			{

				items.map((item, i) => {

					const hasTitle = item.querySelector('title').textContent.length > 0;
					const status = item.querySelector('status').textContent;

					if ( hasTitle ) {

						switch(status) {

							case 'trash':

								return false;
							case 'draft':

								if ( !isDraftShown ) {

									return false;
								}
								break;
							case 'publish':

								if ( !isPublishedShown ) {

									return false;
								}
								break;
							default:
						}

						const postId = item.querySelector('post_id').textContent;
						const isSelected = selectedItems.includes(postId);

						return (

							<SelectItem
								key={postId}
								item={item}
								isSelected={isSelected}
								id={postId}
								onSelectionChange={onPageSelectionChange}
								selectedItems={selectedItems}
								/>
							)
					}

					return false;
				})
			}
			</ul>
		</div>
	)
}

export default ItemList;
